module.exports = __webpack_public_path__ + "img/packages/h5.c514cb.png";